let leavingPage = false

/**
 * True once the app has asked the browser to leave the current document
 * (for example when handing the user off to the API's OAuth endpoint).
 */
export function isLeavingPage(): boolean {
	return leavingPage
}

/**
 * Full-page navigation away from the SPA.
 *
 * WebKit (Safari and every iOS in-app browser) cancels all in-flight requests, including
 * lazily imported chunks, as soon as it accepts a navigation. Recording the intent lets
 * chunk-load recovery tell such an aborted import apart from a stale deployment, so it does
 * not reload the page and cancel the navigation the user just triggered.
 */
export function leavePage(url: string, navigate: (url: string) => void = defaultNavigate): void {
	leavingPage = true
	navigate(url)
}

function defaultNavigate(url: string) {
	window.location.assign(url)
}
